import { render, staticRenderFns } from "./suppressions.vue?vue&type=template&id=877248c2&scoped=true"
import script from "./suppressions.vue?vue&type=script&lang=js"
export * from "./suppressions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877248c2",
  null
  
)

export default component.exports